import React from "react"
import noData from "../../assets/images/Group.svg"

const NodataFound = () => {

    return (
        <>
            <div className="d-flex align-content-center justify-content-center">
                <span>
                    <img src={noData} alt="noData" />
                </span>
            </div>
            <div className="d-flex align-content-center justify-content-center" style={{ top: '10px' }}>
                <h4>No Data Found</h4>
            </div>
        </>
    )
}

export default NodataFound